<template>
  <div>
    <template v-if="galleries.length > 0">
      <div v-for="gallery in galleries" :key="gallery.id">
        <Gallery :gallery="gallery"/>
      </div>
    </template>
    <template v-else>
      <div v-if="!eventClosed">
          <CtaSupport :event-name="eventName" :pica-code="picaCode" v-if="isPromo"/>
          <template v-else>
             <CtaNoPhotosBought :event-name="eventName" :pica-code="picaCode" v-if="!videoOnlySale"/>
          </template>
        </div>
    </template>
  </div>
</template>


<script>

import Gallery from "@/domain/media/galleries/Gallery.vue";
import CtaSupport from "@/domain/checkinDetail/cta/CtaSupport.vue";
import CtaNoPhotosBought from "@/domain/checkinDetail/cta/CtaNoPhotosBought.vue";
import {mapGetters} from "vuex";

export default {
  name: 'UnlockedGalleries',
  components: {CtaNoPhotosBought, CtaSupport, Gallery},
  props: {
    galleries: {
      type: Array,
      required: true
    }
  },
    computed: {
    ...mapGetters('checkinDetail', [
      'checkin',
      'eventName',
      'picaCode',
      'isPromo',
      'eventClosed',
      'videoOnlySale']),
  },
}
</script>

